import type { useI18n } from '@affine/i18n';

import type { WorkspaceDialogService } from '../modules/dialogs';
import type { UrlService } from '../modules/url';

export function registerAffineHelpCommands({
  t: _t,
  urlService: _urlService,
  workspaceDialogService: _workspaceDialogService,
}: {
  t: ReturnType<typeof useI18n>;
  urlService: UrlService;
  workspaceDialogService: WorkspaceDialogService;
}) {
  return () => {};
}
